import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';

function HorizontalLoader(_a) {
    var classes = _a.classes;
    return (React__default.createElement("div", { className: classNames('horizontal-loader', classes) },
        React__default.createElement("div", { className: "bar1 bar" })));
}

export { HorizontalLoader as default };
//# sourceMappingURL=HorizontalLoader.js.map
